import { rootMargin } from '@helpers/animate';
import { CommunityIcon, getSvgIcon } from '@helpers/icons';
import { useInView } from '@hooks/useInView';
import HeadingSummaryBlock from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock';
import { BackgroundVariant } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './JoinCtaCard.styles';
const JoinCtaCard = (props) => {
    const [containerRef, inView] = useInView({ rootMargin }, false, props.pageContext?.isEditMode);
    const icons = React.useMemo(() => props.withIcons
        ? chunk([...Object.values(CommunityIcon), ...Object.values(CommunityIcon)])
        : [], []);
    return (React.createElement(S.Container, { id: props.anchorId, ref: containerRef, "data-animate": inView, "data-primary": props.primaryColour ?? BackgroundVariant.White, translations: props.translations },
        React.createElement(S.Wrapper, null,
            React.createElement(HeadingSummaryBlock, { ...props, summary: props.summary ? `<p>${props.summary}</p>` : undefined, ctas: props.ctas?.map((cta, i) => ({
                    ...cta,
                    buttonType: i === 1 ? 'secondary' : 'primary',
                })), ctaWrapperVariant: props.primaryColour ?? BackgroundVariant.White }),
            icons.length > 0 && (React.createElement(S.IconsWrapper, null, icons.map((iconGroup, i) => {
                if (i < 9) {
                    return (React.createElement(S.Icon, { key: `join-cta-icons-${i}-${props.heading}` }, iconGroup.map((icon, j) => (React.createElement(React.Fragment, { key: `join-cta-icons-${i}-${j}-${props.heading}` }, getSvgIcon(icon))))));
                }
                return;
            }))))));
    // Group icons into chunks of 3
    function chunk(arr) {
        const chunks = [];
        let i = 0;
        const n = arr.length;
        while (i < n) {
            chunks.push(arr.slice(i, (i += 3)));
        }
        return chunks;
    }
};
export default JoinCtaCard;
